module.exports = __webpack_public_path__ + "static/hero-mobile-8ffbb80419e07fa9aee3ab9fa783aaa5.png";